
import { defineComponent } from 'vue';
import DotSpinner from '@/components/EasySpinners/DotSpinner.vue';

export default defineComponent({
    name: "IconSpinner",
    components: {
        DotSpinner
    },
    props: {
        iconUrl: {
            type: String,
            required: false
        }
    },
    setup() {
        
    },
})
